$('.slideshow').slick({
  dots: true,
  infinite: true,
  speed: 300,
  arrows:true,
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: $('.slideshow-arrow-next'),
  prevArrow: $('.slideshow-arrow-prev'),
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
if($('.review-sliders')) $('.review-sliders').slick({
  dots: true,
  infinite: true,
  speed: 300,
  arrows:false,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
